export type MapView = {
  south: number;
  west: number;
  north: number;
  east: number;
  zoom: number;
};

export type MapFrame = {
  latitude: number;
  longitude: number;
  zoom: number;
};

export type NearbyPin = {
  id: string;
  name: string;
  city: string;
  latitude: number;
  longitude: number;
};

export const NEARBY_MIN_ZOOM = 12;

const SAME_POINT_DEGREES = 0.0002;

export function sameMapPoint(leftLat: number, leftLng: number, rightLat: number, rightLng: number): boolean {
  return Math.abs(leftLat - rightLat) < SAME_POINT_DEGREES && Math.abs(leftLng - rightLng) < SAME_POINT_DEGREES;
}

/** A named place always replaces the field. A nameless click clears only a name this map filled. */
export function nameFromPlace(currentName: string, lastFilledName: string, pickedName: string | undefined): string | null {
  const incoming = (pickedName ?? '').trim();
  if (incoming === '' && currentName !== lastFilledName) return null;
  return incoming;
}
